'use client';

import { Box, Container, Image } from '@doist/marketist';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useTranslation } from 'next-i18next';
import css from './flexible-views.module.css';
import { FlexibleViewsSection } from '@/app/components/flexible-views-section/flexible-views-section';
function FlexibleViews() {
  const {
    t
  } = useTranslation('features-teams');
  return <div data-sentry-component="FlexibleViews" data-sentry-source-file="flexible-views.tsx">
            <Box className={css.illustrationContainer} data-sentry-element="Box" data-sentry-source-file="flexible-views.tsx">
                <Image src="/static/features-teams/views-spot.png" width={680} height={200} className={css.illustration} alt="" data-sentry-element="Image" data-sentry-source-file="flexible-views.tsx" />
            </Box>
            <Container width="sm" className={css.headerContainer} data-sentry-element="Container" data-sentry-source-file="flexible-views.tsx">
                <SectionHeader title={t('flexibleViews')} subtitle={t('switchBetweenViews')} size="lg" data-sentry-element="SectionHeader" data-sentry-source-file="flexible-views.tsx" />
            </Container>

            <FlexibleViewsSection colorTheme="seaSalt" data-sentry-element="FlexibleViewsSection" data-sentry-source-file="flexible-views.tsx" />
        </div>;
}
export { FlexibleViews };